// @ts-ignore
import userAgent from 'lib/currentUserAgent';
import { RouterState, LocationDescriptor } from 'lib/ReactRouterTypes';

export function redirectIfMobile(redirectPath: string) {
  return function (
    _: RouterState,
    replaceWith: (location: LocationDescriptor) => void
  ) {
    if (!userAgent.isDesktop()) {
      replaceWith({ pathname: redirectPath });
    }
  }
}
